import { render, staticRenderFns } from "./assess-foot.vue?vue&type=template&id=16d6e775&scoped=true"
import script from "./assess-foot.vue?vue&type=script&lang=js"
export * from "./assess-foot.vue?vue&type=script&lang=js"
import style0 from "./assess-foot.vue?vue&type=style&index=0&id=16d6e775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6e775",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonNumberAnimate: require('/builds/wj/fe/wenjuan-homesite/components/common/number-animate.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default})
